import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ContenedorRoutingModule } from './contenedor-routing.module';
import { IngresoComponent } from '../../ingreso/ingreso.component';
import { ContenedorComponent } from '../contenedor.component';
import { MaterialModule } from '../../../configuracion/material.module';
import { PieComponent } from '../../pie/pie.component';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpLoaderTranslatorFactory } from '../../../configuracion/app.factories';
import { MissingTranslationHandlerDIAN } from '../../../configuracion/missing-translation-handler-dian';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DatepickerModule } from '@dian-cmp/datepicker';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { DReciboPagoModule } from '@dian-cmp/recibo-pago';
import { DReciboPagoExteriorModule } from '@dian-cmp/recibo-pago490-exterior';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2Webstorage } from 'ngx-webstorage';
import { CrearFormularioComponent } from '../../crear-formulario/crear-formulario.component';
import { ModalService } from '../../../modal/services/modal.service';
import { BorradoresComponent } from '../../borradores/borradores.component';
import { IngresoService } from '../../services/ingreso.service';
import { DRenta210IngresoServicios } from '@dian-api/renta210-ingreso';
import { GeneralService } from '../../../services/general.service';
import { FraccionComponent } from '../../fraccion/fraccion.component';
import { CuotasComponent } from '../../cuotas/cuotas.component';
import { PresentadosComponent } from '../../presentados/presentados.component';
import { InfoSesionComponent } from '../../shared/InfoSesion/infoSesion.component';
import { DefinitivosComponent } from '../../definitivos/definitivos.component';
import { SugeridaComponent } from '../../sugerida/sugerida.component';
import { ModoDiligenciemientoComponent } from '../../shared/modals/modo-diligenciemiento/modo-diligenciemiento.component';
import { DRenta210v17Servicios } from '@dian-api/renta210v17';
import { DRenta210v18Servicios } from '@dian-api/renta210v18';
import { Formulario210Servicio } from '../../../services/formulario.servicio';
import { DOperacionesGeneralesIngresoServicio } from '@dian-cmp/formulario';
import { CalculoExtemporaneidadComponent } from '../../shared/modals/calculo-extemporaneidad/calculo-extemporaneidad.component';
import { ExtemporaneidadComponent } from '../../../modal/extemporaneidad/extemporaneidad.component';
import { DSugeridaNubeServicios } from '@dian-api/sugerida-nube';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule, 
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({ 
      prefix: 'DIAN', 
      separator: '-', 
      caseSensitive:true 
    }),
    //Traductor
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderTranslatorFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler, 
        useClass: MissingTranslationHandlerDIAN
      }
    }),
    //Material
    FlexLayoutModule,
    MaterialModule,
    DatepickerModule,
    DateValueAccessorModule,  
    DReciboPagoModule,   
    DReciboPagoExteriorModule,
    ContenedorRoutingModule
  ],
  declarations: [
    ContenedorComponent,
    IngresoComponent,
    PieComponent,
    CrearFormularioComponent,
    BorradoresComponent,
    FraccionComponent,
    CuotasComponent,
    PresentadosComponent,
    InfoSesionComponent,
    DefinitivosComponent,
    SugeridaComponent,
    ModoDiligenciemientoComponent,
    CalculoExtemporaneidadComponent,
    ExtemporaneidadComponent
       
  ],
  entryComponents: [ModoDiligenciemientoComponent, CalculoExtemporaneidadComponent,
    ExtemporaneidadComponent
  ],
  providers: [
    ModalService,
    IngresoService,
    DRenta210IngresoServicios,
    GeneralService,
    Formulario210Servicio,
    DRenta210v17Servicios,
    DRenta210v18Servicios,
    DSugeridaNubeServicios,
    DatePipe,
    
  ]
})
export class ContenedorModule { }



// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/components/contenedor/modules/contenedor.module.ts